export default "__VITE_ASSET__HWu0YEVC__"